import { cn } from "@/lib/utils";

const LOGO_LOCKUP = "/images/clawcraft-logo.svg";
const LOGO_MARK = "/images/clawcraft-logo-square-transparent.png";

/** The Clawcraft claw mark (square), from the brand asset. Decorative — the
 * meaning is carried by adjacent text or an accessible label on the link. */
export function ClawMark({ className }: { className?: string }) {
  return (
    <img
      src={LOGO_MARK}
      alt=""
      aria-hidden="true"
      className={cn("object-contain", className)}
    />
  );
}

interface BrandLogoProps {
  className?: string;
  /** Height class applied to the logo; width scales automatically. */
  markClassName?: string;
  /** Mark only, without the wordmark (e.g. a collapsed rail). */
  withWordmark?: boolean;
  /** @deprecated The wordmark is baked into the lockup SVG now; this prop is
   *  ignored. Kept so existing callers (marketing header/footer) still compile
   *  until they drop it. */
  wordmarkClassName?: string;
}

/** The full brand lockup — claw mark + wordmark — from the brand SVG. */
export function BrandLogo({
  className,
  markClassName = "h-8",
  withWordmark = true,
}: BrandLogoProps) {
  if (!withWordmark) {
    return <ClawMark className={cn("w-auto", markClassName, className)} />;
  }
  return (
    <img
      src={LOGO_LOCKUP}
      alt="Clawcraft"
      className={cn("w-auto", markClassName, className)}
    />
  );
}
